module.exports = __webpack_public_path__ + "img/dundrum2_small.c095c131.png";